"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CarouselLoaderPager = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreMatchMedia = _interopRequireDefault(require("@vfuk/core-match-media"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _reactI18next = require("react-i18next");
var Styled = _interopRequireWildcard(require("./styles/CarouselLoaderPager.style"));
var _locales = require("../../locales");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var CarouselLoaderPager = /*#__PURE__*/function (_PureComponent) {
  _inherits(CarouselLoaderPager, _PureComponent);
  var _super = _createSuper(CarouselLoaderPager);
  function CarouselLoaderPager() {
    var _this;
    _classCallCheck(this, CarouselLoaderPager);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.loadingBarFrameRate = 5;
    _this.state = {
      progress: 0
    };
    _this.loadingInterval = void 0;
    return _this;
  }
  _createClass(CarouselLoaderPager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startLoading();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.active) {
        this.reset();
      }
      if (prevProps.active !== this.props.active && this.props.autoplay) {
        this.startLoading();
      }
      if (this.props.active && !this.props.autoplay) {
        this.setState({
          progress: 1
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearLoadingInterval();
    }
  }, {
    key: "clearLoadingInterval",
    value: function clearLoadingInterval() {
      if (this.loadingInterval) {
        clearTimeout(this.loadingInterval);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.clearLoadingInterval();
      this.setState({
        progress: 0
      });
    }
  }, {
    key: "nextLoadStep",
    value: function nextLoadStep(progress, frameInterval) {
      if (progress >= 1) {
        this.reset();
        this.nextSlide();
        return;
      }
      progress += 1 / (this.props.timeout / frameInterval);
      this.setState({
        progress: progress < 1 ? progress : 1
      });
    }
  }, {
    key: "startLoading",
    value: function startLoading() {
      var _this2 = this;
      if (this.props.active) {
        var frameInterval = 1000 / this.loadingBarFrameRate;
        this.loadingInterval = setInterval(function () {
          return _this2.nextLoadStep(_this2.state.progress, frameInterval);
        }, frameInterval);
      }
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      var nextIndex = this.props.index + 1;
      var nextActive = nextIndex >= this.props.pagerCount ? 0 : nextIndex;
      this.props.onChange(nextActive);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        progress: 1
      });
      this.props.onSlideControlChange(false);
      if (this.props.active) {
        this.clearLoadingInterval();
      } else {
        this.props.onChange(this.props.index);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement(Styled.CarouselLoaderPager, {
        active: this.props.active,
        inverse: this.props.inverse,
        onClick: function onClick() {
          return _this3.handleClick();
        },
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix)
      }, /*#__PURE__*/_react["default"].createElement(Styled.Bar, {
        active: this.props.active,
        progress: this.state.progress,
        transitionTime: 1000 / this.loadingBarFrameRate,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'bar')
      }), /*#__PURE__*/_react["default"].createElement(_coreMatchMedia["default"], {
        breakpoint: "lg",
        andAbove: true
      }, /*#__PURE__*/_react["default"].createElement(Styled.Title, {
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'title')
      }, this.props.title)), /*#__PURE__*/_react["default"].createElement(Styled.SrText, {
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'sr-text')
      }, this.props.t('ItemCountOfTotalCount', {
        index: this.props.index + 1,
        pagerCount: this.props.pagerCount
      }), this.props.active && this.props.t('Currently Active')));
    }
  }]);
  return CarouselLoaderPager;
}(_react.PureComponent);
exports.CarouselLoaderPager = CarouselLoaderPager;
CarouselLoaderPager.displayName = "CarouselLoaderPager";
var _default = (0, _reactI18next.withTranslation)(_locales.componentName)(CarouselLoaderPager);
exports["default"] = _default;